import { Injectable } from '@angular/core';

import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PATHS } from '../../shared/constants/paths';
import { NavigationHelperService } from '../../shared/helpers/navigation.helpers.service';
import { BetterBuysService } from './better-buys.service';

@Injectable({
  providedIn: 'root',
})
export class BetterBuysGuardService {
  constructor(
    private betterBuysService: BetterBuysService,
    private navigationHelperService: NavigationHelperService,
  ) {}

  canActivate(): Observable<boolean> {
    const betterBuysFlag$ = this.betterBuysService.getBetterBuysFlag();
    const betterBuysLoaded$ = this.betterBuysService.getBetterBuysLoaded();
    return combineLatest([betterBuysFlag$, betterBuysLoaded$]).pipe(
      filter(([betterBuysFlag, betterBuysLoaded]) => betterBuysLoaded),
      map(([betterBuysFlag, betterBuysLoaded]) => {
        if (betterBuysFlag) {
          return true;
        } else {
          this.navigationHelperService.routeTo(PATHS.HOME);
          return false;
        }
      }),
    );
  }
}
